<template name="forwaringUser">
  <div class="forwaring">
    <div>
      <span>{{$t('forwardInvitation')}}</span><i @click="closeForwaring" class="iconfont icon-close"></i>
    </div>
    <div id="addUserList">
      <div class="userList" ref="child" v-for="(item, index) in addUserList" :key="index" v-if="addUserList.length">
        <div class="row visitorMessge">
          <div class="col-6 text">{{$t('visitorInfo')}}</div>
          <div class="col-6 icon" @click="deleteOne(index)" v-if="addUserList.length>1"><img src="../../assets/images/external/2-copy-12.png"></div>
        </div>
        <div class="userOne">
          <div class="row name">
            <div class="col-5 name-title">{{$t('name')}}</div>
            <div class="col-7 text-name"><input  type="text" v-model="item.primaryVisitor.username" name="" :placeholder="$t('typeTheName')"></div>
          </div>
          <label class="error-msg"   ref="validName" style="display: none;">
            {{$t('inputName')}}
          </label>
          <div class="phone" ref="phone">
            <div class="row">
              <div class="col-5 name-title add-phone">
                <span @click="toggleInput(index)"> {{ item.primaryVisitor.pickedContact }}<i class="iconfont icon-down"></i></span>
                <div class="control-label"  ref="showOption" style="display: none;">
                  <div class="form-group">
                    <input type="radio"  :value="$t('mobile')" v-model="item.primaryVisitor.pickedContact">
                    <label  @click="hideContactSelect(index, $event)">{{$t('mobile')}}</label>
                  </div>
                  <div class="form-group">
                    <input type="radio" id="mail" :value="$t('email')" v-model="item.primaryVisitor.pickedContact">
                    <label  @click="hideContactSelect(index, $event)">{{$t('email')}}</label>
                  </div>
                </div>
              </div>
              <div class="col-7 text-name">
                <input type="text" name="contact"
                      :placeholder=" $t('type')  + item.primaryVisitor.pickedContact"
                      @blur="checkContact(index, $event)"
                      v-model="item.primaryVisitor.contact">
              </div>
            </div>
          </div>
          <label class="error-msg"   ref="validPhone" style="display: none;">
            {{$t('inputPhone')}}
          </label>
          <label class="error-msg"   ref="validEamil" style="display: none;">
            {{$t('inputEmail')}}
          </label>
          <label class="error-msg" v-if="item.primaryVisitor.pickedContact == $t('mobile')" v-show="errorMsg" ref="validContact" >
            {{$t('rightMobile')}}
          </label>
          <label class="error-msg" v-show="errorMsg" v-if="item.primaryVisitor.pickedContact == $t('email')" ref="validContact">{{$t('rightEmail')}}</label>
        </div>
      </div>
    </div>
    <div class="add-otherUser">
      <div @click="addOtherUser">
        <i class="iconfont icon-add"></i><span>{{$t('addotherVisitor')}}</span>
      </div>
    </div>
    <div class="option-btn">
      <div class="row">
        <div class="cancel" @click="closeForwaring">{{$t('Cancel')}}</div>
        <div class="comfirm" @click="comfirmForwaring">{{$t('ConfirmFoward')}}</div>
      </div>
    </div>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>
<script type="text/javascript">
  import addUser from '@/views/external/addUser.vue';
  import { clickToForward } from '@/utils/api';
  import { checkNested, regExp } from '@/utils/utils';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    name: 'forwaringUser',
    components: {
      addUser,
      Loading,
    },
    props: {
      invitationId: String,
    },
    data() {
      return {
        showOption: false,
        validContact: true,
        addUserList: [{
            'primaryVisitor': {
               username: '',
               pickedContact: this.$t('mobile'),
               contact: '',
            },
          }
        ],
        status: 'forwaringModal',
        errorMsg: false,
        showErrorMsg: false,
        isLoading: false,
        showNameErrorMsg: false,
        showPoneErrorMsg: false,
        showEmailErrorMsg: false,
      }
    },
    methods: {
      closeForwaring() {
        this.addUserList = [{
          'primaryVisitor': {
             username: '',
             pickedContact: this.$t('mobile'),
             contact: '',
          },
        }
        ];
        this.errorMsg = false;
        this.$refs.validName.map( function(item,index) {
          item.style.display = 'none';
        });
        this.$refs.validPhone.map( function(item,index) {
          item.style.display = 'none';
        });
        this.$refs.validContact.map( function(item,index) {
          item.style.display = 'none';
        });
        this.$emit('closeForwaring', false);
      },
      addOtherUser() {
        const primaryVisitor = {'primaryVisitor': {
          username: '',
          pickedContact: this.$t('mobile'),
          contact: '',
        }}
        this.addUserList.push(primaryVisitor);
        // console.log(this.addUserList);
      },
      deleteOne(index) {
        this.addUserList.splice(index,1);
        // console.log(this.addUserList);
      },
      toggleInput(index) {
        if (this.$refs.showOption[index].style.display == 'none') {
          this.$refs.showOption[index].style.display = 'block';
        } else {
          this.$refs.showOption[index].style.display = 'none';
        }
      },
      checkContact(index, event) {
        // console.log(event);
        // console.log(event.target.value);
        // console.log(index);
        //console.log(e.target.dataset);
        //this.errorMsg = true;
        if (this.addUserList[index].primaryVisitor.pickedContact === this.$t('mobile')) {
          // console.log(regExp.phone.test(event.target.value));
          if (regExp.phone.test(event.target.value)) {
            this.$refs.validContact[index].style.display = 'none';
          } else {
            this.$refs.validPhone[index].style.display = 'none';
            this.$refs.validContact[index].style.display = 'block';
          }
        } else {
          if (regExp.email.test(event.target.value)) {
            this.$refs.validEamil[index].style.display = 'none';
            this.$refs.validContact[index].style.display = 'none';
          } else {
            this.$refs.validEamil[index].style.display = 'none';
            this.$refs.validContact[index].style.display = 'block';
          }
        }
      },
      hideContactSelect(index,event) {
        // console.log(event.target.textContent);
        this.$refs.showOption[index].style.display = 'none';
        this.$refs.validContact[index].style.display = 'none';
        this.addUserList[index].primaryVisitor.contact = '';
        this.addUserList[index].primaryVisitor.pickedContact = event.target.textContent;
        
      },
      comfirmForwaring() {
        var phoneVisitorList = [];
        var emailVisitorList = [];
        // console.log(this.addUserList);
        this.addUserList.map((item, index) => {
          const phoneVisitorData = {
            name: '',
            phone: ''
          }
          const emailVisitorData = {
            name: '',
            email: ''
          }
          item.primaryVisitor.username == '' ? this.$refs.validName[index].style.display = 'block' : this.$refs.validName[index].style.display = 'none';
          if (item.primaryVisitor.contact == '' && item.primaryVisitor.pickedContact == this.$t('mobile')) {
            this.$refs.validPhone[index].style.display = 'block'
            this.$refs.validContact[index].style.display = 'none'
          } else {
            this.$refs.validPhone[index].style.display = 'none' ;
          }

          if (item.primaryVisitor.contact == '' && item.primaryVisitor.pickedContact != this.$t('mobile')) {
            this.$refs.validEamil[index].style.display = 'block'
            this.$refs.validContact[index].style.display = 'none'
          } else {
            this.$refs.validEamil[index].style.display = 'none' ;
          }
          this.showErrorMs = this.$refs.validContact.findIndex(x => x.style.display == 'block') !=-1;
          this.showNameErrorMsg = this.$refs.validName.findIndex(x => x.style.display == 'block') !=-1;
          this.showPoneErrorMsg = this.$refs.validPhone.findIndex(x => x.style.display == 'block') !=-1;
          this.showEmailErrorMsg = this.$refs.validEamil.findIndex(x => x.style.display == 'block') !=-1;
          // console.log(this.showNameErrorMsg);
          if (!this.showErrorMs && !this.showNameErrorMsg && !this.showPoneErrorMsg && !this.showEmailErrorMsg) {
            if (item.primaryVisitor.pickedContact == this.$t('mobile') && this.$refs.validContact[index].style.display == 'none') {
              phoneVisitorData.name = item.primaryVisitor.username,
              phoneVisitorData.phone = item.primaryVisitor.contact,
              phoneVisitorList.push(phoneVisitorData);
            } else if ( this.$refs.validContact[index].style.display == 'none'){
              emailVisitorData.name = item.primaryVisitor.username,
              emailVisitorData.email = item.primaryVisitor.contact,
              emailVisitorList.push(emailVisitorData);
            }
          }
        });
        if (!this.showErrorMs && !this.showNameErrorMsg && !this.showPoneErrorMsg && !this.showEmailErrorMsg) {
          const postData = {
            invitationId: this.invitationId,
            phoneVisitorList: phoneVisitorList,
            emailVisitorList: emailVisitorList
          }
          // console.log(postData);
          this.$emit('isLoading', true);
          clickToForward(postData).then((res) => {
            if (checkNested(res, 'data', 'content', 'model')) {
              // console.log(res)
              if (res.data.content.status == 1) {
                this.$emit('isLoading', false);
                const data = {
                  'message': res.data.content.message,
                  'currentTxt': this.status,
                  'status': res.data.content.status
                }
                this.$emit('closeForwaring', false);
                this.$emit('comifrmModal', true, data);
              } else {
                this.$emit('isLoading', false);
                const data = {
                  'message': res.data.content.message,
                  'currentTxt': this.status,
                  'status': res.data.content.status
                }
                this.$emit('closeForwaring', true);
                this.$emit('comifrmModal', true, data);  
              }
            }
          })
        } 
      },
    }
  }
</script>

<style lang="scss" scoped>
@import "../../scss/variables.scss";
  .forwaring {
    border-radius: 4px;
    background: #fff;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    width: 400px;
    margin: 0 auto;
    left: calc(100%/2 - 400px/2);
    padding: 12px;
    padding-bottom: 20px;
    max-height: 480px;
    overflow-y: auto;
    @include respond-to('sm-max') {
      width: 80%;
      margin: 0 auto;
      left: calc(100%/2 - 80%/2);
    }
    @include respond-to('ml') {
      width: 400px;
      margin: 0 auto;
      left: calc(100%/2 - 400px/2);    
    }
    & > div:first-child {
      span {
        font-size: 16px;
        color: #4a4a4a;
        font-weight: bold;
      }
      i {
        cursor: pointer;
        float: right;
        font-size: 30px;
        margin-top: -10px;
        color: rgba(34, 34, 34, 0.55);
      }

    }
  }
  .option-btn {
    margin-top: 20px;
    .row {
      margin: 0;
      width: 100%;
      div {
        width: 45%;
        height: 40px;
        cursor: pointer;
        line-height: 40px;
        border-radius: 5px;
        font-size: 15px;
        text-align: center;
      }
      .cancel {
        color: #9b9b9b;
        margin-right: 10%;
        border: solid 1px #979797;
      }
      .comfirm {
        color: #fff;
        background-image: linear-gradient(72deg, #f36443, #e42029);
      }
    }
  }
  .add-otherUser {
    margin: 0 12px;
    padding-left: 15px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 0 15px rgba(100, 100, 100, 0.1);
    div {
      padding: 12px;
      padding-left: 0;
      cursor: pointer;
      i {
        color: #e42029;
        margin-right: 5px;
      }
      span {
        font-size: 13px;
        color: #4a4a4a;
        font-weight: 600;
      }
    }
  }

  .userList {
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 0 15px rgba(100, 100, 100, 0.1);
    margin: 15px 12px;
    padding: 15px;
    padding-bottom: 0;
    .visitorMessge {
      margin: 0;
      .text {
        padding: 0;
      }
      .icon {
        text-align: right;
        padding-right: 0;
      }
    }
   .row {
     margin: 0;
   }
   .userOne {
     width: 100%;
     .name,
     .phone {
       width: 100%;
       margin: 0;
       align-items: center;
       padding: 15px 0;
       border-bottom: 1px solid rgba(57, 74, 84, 0.08);
       .phone-error {
        border-bottom: 1px solid red;
       }
       .name-title {
         padding: 0;
         color: #4a4a4a;
         font-size: 13px;
       }
       .add-phone {
         cursor: pointer;
       }
       .text-name {
         float: right;
         padding: 0;
         input {
           width: 100%;
           color: #4a4a4a;
           font-size: 13px;
           text-align: right;
           &::-webkit-input-placeholder {
             color: #929292;
           }
         }
       }
     }
     .phone {
      border-bottom: none;
       i {
         font-size: 10px;
         margin-left: 15px;
       }
       .row {
         align-items: center;
       }
       .add-phone {
         border-right: 1px solid rgba(57, 74, 84, 0.08);
       }
     }
     .add-phone {
       position: relative;
       .control-label {
         position: absolute;
         z-index: 99;
         padding: 10px 15px;
         text-align: left;
         background: #fff;
         left: 0;
         width: 96px;
         font-size: 14px;
         color: #929292;
         box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.07);
         top: 26px;
         .form-group {
           margin-bottom: 0;
           cursor: pointer;
           line-height: 30px;
           input {
             display: none;
           }
           label {
             margin-bottom: 0;
           }
         }
       }
     }
   }
  }
  .error-msg {
    color: #e42029;
    font-size: 11px;
    text-align: right;
    width: 100%;
    &.right-padding {
      padding-right: 12px;
    }
  }

</style>